// extracted by mini-css-extract-plugin
module.exports = {"warranty-return_separator":"warranty-return-policy_warranty-return_separator__c8JYQ"};